export default __webpack_public_path__ + "static/media/work-portfolio-img3.e0fd28a2.png";